const FoodBlogProject = () => {
  const imgStyle = {
    margin: "10px 0",
    boxShadow: "0 0 7px 5px rgba(0, 0, 0, 0.05)",
  }
  return (
    <div>
      <h3>Food Blog</h3>
      <p>
        <a href="https://github.com/GeorgeCGarman/food-blog-frontend">
          view on Github
        </a>
      </p>
      <img
        style={imgStyle}
        src="screenshots/Screenshot 2022-09-25 at 17.57.52.png"
        alt="screenshot"
        width="100%"
      />
      <img
        style={imgStyle}
        src="screenshots/Screenshot 2022-09-25 at 17.57.46.png"
        alt="screenshot"
        width="100%"
      />
      <img
        style={imgStyle}
        src="screenshots/Screenshot 2022-09-25 at 17.57.59.png"
        alt="screenshot"
        width="100%"
      />
    </div>
  )
}

export default FoodBlogProject
